import React, { useContext, useEffect, useRef, useState } from 'react'
import { View, Text, FlatList } from 'react-native'
import { OptionsItem } from '../OptionsItem'
import { InitialInputVoiceSearch } from '../VoiceSearch/InitialInput/InitialInput'
import { corporateColor } from '../../theme/colors'
import { ControlServicesContext } from '../../context/SeaWater/ControlServices/ControlServicesContext'
import { BoardingOption } from '../../context/SeaWater/ControlServices/types'
import { useTranslation } from 'react-i18next'

interface OptionPress {
  serviceId: number
  category: number
  serviceName: string
  categoryFailure: number
  boardingName: string
}
interface Props {
  getServiceId: (value: OptionPress) => void
  initialValues?: OptionPress
}

const INITIAL_VALUES = {
  category: 0,
  serviceId: 0,
  serviceName: '',
  categoryFailure: 0,
  boardingName: '',
}

export const Services = ({ getServiceId, initialValues }: Props) => {
  const { boardings } = useContext(ControlServicesContext)
  const [selectedOption, setSelectedOption] = useState<OptionPress>(initialValues ?? INITIAL_VALUES)
  const [search, setSearch] = useState('')
  const [filteredData, setfilteredData] = useState<BoardingOption[]>([])
  const { t } = useTranslation()
  const handleOptionPress = (values: OptionPress) => {
    setSelectedOption(values.serviceId === selectedOption.serviceId ? INITIAL_VALUES : values)
  }
  const getSearchValue = (value: string) => setSearch(value)
  const isFirstRender = useRef(true)
  useEffect(() => {
    if (!isFirstRender.current) {
      if (selectedOption !== null) {
        getServiceId(selectedOption)
      }
    }
    isFirstRender.current = false
  }, [selectedOption])

  useEffect(() => {
    setfilteredData(
      boardings.filter((item) => item.name.toLowerCase().includes(search.toLowerCase())),
    )
  }, [search])

  return (
    <View>
      <Text style={{ textAlign: 'center', fontWeight: 'bold', color: corporateColor }}>
        {t('Seleccione servicio')}
      </Text>
      <InitialInputVoiceSearch
        hasInput
        placeholder={t('Buscar servicio')}
        getSearchValue={getSearchValue}
      />
      <FlatList
        style={{ marginTop: 10 }}
        data={filteredData}
        keyExtractor={(item, index) => `${item.id}-${index}`}
        renderItem={({ item }) => (
          <OptionsItem
            item={item}
            onPress={() =>
              handleOptionPress({
                serviceId: item.id,
                category: item.category,
                serviceName: item.serviceName,
                categoryFailure: item.categoryFailure,
                boardingName: item.boardingName,
              })
            }
            isSelected={item.id === selectedOption.serviceId}
          />
        )}
        horizontal
      />
    </View>
  )
}
